var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 160,
    viewBox: "0 0 162 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.2502 56.832C71.2285 56.832 67.146 60.9145 67.146 65.9362C67.146 70.862 70.9985 74.8487 76.0202 75.0212C76.1735 75.002 76.3268 75.002 76.4418 75.0212C76.4802 75.0212 76.4993 75.0212 76.5377 75.0212C76.5568 75.0212 76.5568 75.0212 76.576 75.0212C81.4827 74.8487 85.3352 70.862 85.3543 65.9362C85.3543 60.9145 81.2718 56.832 76.2502 56.832Z",
    fill: "#6EAEFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9863 80.1191C80.6388 76.5541 71.918 76.5541 66.5322 80.1191C64.098 81.7482 62.7563 83.9524 62.7563 86.3099C62.7563 88.6674 64.098 90.8524 66.513 92.4624C69.1963 94.2641 72.723 95.1649 76.2497 95.1649C79.7763 95.1649 83.303 94.2641 85.9863 92.4624C88.4013 90.8332 89.743 88.6482 89.743 86.2716C89.7238 83.9141 88.4013 81.7291 85.9863 80.1191Z",
    fill: "#6EAEFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M97.3144 67.0667C97.6211 70.7851 94.9761 74.0434 91.3153 74.4842C91.2961 74.4842 91.2961 74.4842 91.2769 74.4842H91.2194C91.1044 74.4842 90.9894 74.4842 90.8936 74.5226C89.0344 74.6184 87.3286 74.0242 86.0444 72.9317C88.0186 71.1684 89.1494 68.5234 88.9194 65.6484C88.7853 64.0959 88.2486 62.6776 87.4436 61.4701C88.1719 61.1059 89.0153 60.8759 89.8778 60.7992C93.6344 60.4734 96.9886 63.2717 97.3144 67.0667Z",
    fill: "#6EAEFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.147 84.797C100.994 86.6561 99.8056 88.2661 97.8123 89.3586C95.8956 90.4128 93.4806 90.9111 91.0848 90.8536C92.4648 89.6078 93.2698 88.0553 93.4231 86.407C93.6148 84.0303 92.484 81.7495 90.2223 79.9286C88.9381 78.9128 87.4431 78.1078 85.814 77.5136C90.0498 76.287 95.3781 77.1111 98.6556 79.7561C100.419 81.1745 101.32 82.957 101.147 84.797Z",
    fill: "#6EAEFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_1916_15098)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81,
    cy: 80,
    rx: 24,
    ry: 23,
    fill: "#6EAEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 80C104.5 92.4066 93.999 102.5 81 102.5C68.001 102.5 57.5 92.4066 57.5 80C57.5 67.5934 68.001 57.5 81 57.5C93.999 57.5 104.5 67.5934 104.5 80Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1916_15098",
    x: 0.200001,
    y: 0.200001,
    width: 161.6,
    height: 159.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.4,
    result: "effect1_foregroundBlur_1916_15098"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.4218858e0e0ff192cda270251e65a276.svg";
export { ForwardRef as ReactComponent };